<script setup lang="ts">
import {useMusicUploadStore} from "@/stores/useMusicUploadStore.ts";
import {storeToRefs} from "pinia";

const uploadStore = useMusicUploadStore();
const {isPending} = storeToRefs(uploadStore);

</script>

<template>
  <!-- Blur-/Grauschleier über der Karte, solange eine Operation läuft. pointer-events-none, damit
       das Overlay nie Klicks abfängt. Setzt voraus, dass der Eltern-Container positioniert ist
       (relative/absolute) – sonst spannt sich inset-0 über den nächsten positionierten Vorfahren. -->
  <div
      class="pointer-events-none absolute inset-0 rounded-xl transition-all border-3 border-black delay-200 duration-500"
      :class="isPending
        ? 'animate-pulse opacity-100 backdrop-grayscale backdrop-blur-xs'
        : 'opacity-0'"
  />
</template>
